module.exports = __webpack_public_path__ + "img/partner_2_2x.aaa1415a.png";